import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { authStore } from "@/lib/api";
import { useEffect } from "react";
import { LayoutDashboard, Users, CalendarCheck, Mail, LogOut } from "lucide-react";

const links = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/admin/leads", label: "Leads", icon: Users },
    { to: "/admin/demos", label: "Demo Requests", icon: CalendarCheck },
    { to: "/admin/contacts", label: "Enquiries", icon: Mail },
];

export default function AdminLayout() {
    const nav = useNavigate();
    const user = authStore.getUser();
    useEffect(() => {
        if (!user || !["super_admin", "admin", "sales", "marketing"].includes(user.role)) {
            nav("/admin/login");
        }
    }, [nav, user]);
    if (!user) return null;

    const signOut = () => { authStore.clear(); nav("/admin/login"); };

    return (
        <div data-testid="admin-layout" className="min-h-screen bg-[#F7F9FC] flex">
            <aside className="w-64 bg-[#0B1930] text-white flex flex-col p-6 min-h-screen">
                <div className="flex items-center gap-2.5 mb-10">
                    <div className="w-8 h-8 rounded-md bg-gradient-to-br from-[#E8B923] to-[#C99F0F] flex items-center justify-center text-navy font-serif text-lg font-bold">C</div>
                    <div>
                        <div className="font-serif text-lg">Colecle</div>
                        <div className="text-white/40 text-[10px] font-mono tracking-widest">ADMIN</div>
                    </div>
                </div>
                <nav className="space-y-1 flex-1">
                    {links.map((l) => (
                        <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) =>
                            `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition ${isActive ? "bg-white/10 text-white" : "text-white/60 hover:text-white hover:bg-white/5"}`
                        } data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
                            <l.icon className="w-4 h-4" /> {l.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="pt-4 border-t border-white/10">
                    <div className="text-xs text-white/50 mb-3">
                        <div>{user.full_name}</div>
                        <div className="font-mono text-[10px] mt-0.5">{user.role}</div>
                    </div>
                    <button data-testid="admin-signout" onClick={signOut} className="flex items-center gap-2 text-white/60 hover:text-white text-sm">
                        <LogOut className="w-4 h-4" /> Sign out
                    </button>
                </div>
            </aside>
            <main className="flex-1 p-8 lg:p-10">
                <Outlet />
            </main>
        </div>
    );
}
